// Conversion effects — Big Pet Shop
// Fade-in-on-scroll (opt-in via .fade-in-section) and a best-effort
// count-up on the Judge.me review badge.
//
// SAFETY: every fade-in element gets a hard fallback timer that forces
// it visible after 2s no matter what. Content must never get stuck
// hidden, even if IntersectionObserver misbehaves on a very tall
// element or the browser does something unexpected.
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var fadeEls = document.querySelectorAll('.fade-in-section');
  var manualCountEls = document.querySelectorAll('[data-count-up]');

  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      if (el.classList.contains('fade-in-section')) {
        el.classList.add('is-visible');
      }
      if (el.hasAttribute('data-count-up')) {
        countUpNumber(el, parseInt(el.getAttribute('data-count-up'), 10) || 0);
      }
      obs.unobserve(el);
    });
  }, { threshold: 0.01 });

  fadeEls.forEach(function (el) {
    obs.observe(el);
    // Fail-safe: force visible after 2s regardless of intersection state.
    setTimeout(function () {
      el.classList.add('is-visible');
    }, 2000);
  });

  manualCountEls.forEach(function (el) {
    obs.observe(el);
  });

  function countUpNumber(el, end, duration) {
    duration = duration || 1500;
    var start = null;
    function step(ts) {
      if (start === null) start = ts;
      var progress = Math.min((ts - start) / duration, 1);
      el.textContent = Math.floor(progress * end).toLocaleString();
      if (progress < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  // ---- Best-effort Judge.me review count-up (unchanged, already working) ----
  var judgeMeAttempts = 0;
  var judgeMeMaxAttempts = 20;

  function tryJudgeMe() {
    judgeMeAttempts++;
    var textEl = document.querySelector('.jdgm-prev-badge__text');

    if (textEl && !textEl.dataset.cvrDone) {
      var match = textEl.textContent.match(/(\d+)/);
      if (match) {
        var targetNum = parseInt(match[1], 10);
        var suffix = textEl.textContent.replace(/^\s*\d+\s*/, '');
        textEl.dataset.cvrDone = 'true';

        var jmObs = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            animateJudgeMe(textEl, targetNum, suffix);
            jmObs.unobserve(entry.target);
          });
        }, { threshold: 0.01 });
        jmObs.observe(textEl);

        // Fail-safe here too.
        setTimeout(function () {
          if (!textEl.dataset.cvrAnimated) {
            animateJudgeMe(textEl, targetNum, suffix);
          }
        }, 2500);
      }
      return;
    }

    if (judgeMeAttempts < judgeMeMaxAttempts) {
      setTimeout(tryJudgeMe, 500);
    }
  }

  function animateJudgeMe(el, end, suffix, duration) {
    el.dataset.cvrAnimated = 'true';
    duration = duration || 1500;
    var start = null;
    function step(ts) {
      if (start === null) start = ts;
      var progress = Math.min((ts - start) / duration, 1);
      el.textContent = Math.floor(progress * end) + ' ' + suffix.trim();
      if (progress < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  setTimeout(tryJudgeMe, 500);
})();
